import { Button, Col, Divider, Drawer, Row, Tooltip } from "antd";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { UserInfo } from "../../../context";
import axios from "axios";
import { EditOutlined, CloseOutlined } from "@ant-design/icons";
// import ImgCrop from "antd-img-crop";
import EditCredentials from "./EditCredentials";
import EditPersonal from "./EditPersonal";
import EditBusiness from "./EditBusiness";
import EditContact from "./EditContact";

const DescriptionItem = ({ title, content }) => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">{title}:</p>
    {content}
  </div>
);

const PasswordItem = () => (
  <div className="site-description-item-profile-wrapper">
    <p className="site-description-item-profile-p-label">Password:</p>
    &#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;&#8226;
  </div>
);

const AccountDetails = ({ open, close }) => {
  const { userData } = useContext(UserInfo);
  const [merchantInfo, setMerchantInfo] = useState({
    data: [],
    ready: false,
  });
  const [editPersonal, setEditPersonal] = useState(false);
  const [editBusiness, setEditBusiness] = useState(false);
  const [editContact, setEditContact] = useState(false);
  const [editCredentials, setEditCredentials] = useState(false);

  const getMyMerchantInfo = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/my-merchant-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantInfo({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMyMerchantInfo();
  }, [getMyMerchantInfo]);

  return (
    <Drawer onClose={close} open={open} placement="right" closable={false}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <div style={{ flexGrow: 1 }}></div>
        <div>
          <Tooltip title="Close">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                close();
              }}
              icon={<CloseOutlined />}
            />
          </Tooltip>
        </div>
      </div>
      {merchantInfo.ready && (
        <>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Personal</p>
            </div>
            <div>
              <Tooltip title="Edit Personal">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    // setSelectedData(text);
                    setEditPersonal(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Full Name"
                content={`${merchantInfo.data[0].reg_firstname} ${merchantInfo.data[0].reg_lastname}`}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Address"
                content={`${merchantInfo.data[0].reg_street}, ${
                  merchantInfo.data[0].reg_barangay
                }, ${merchantInfo.data[0].reg_city.toLowerCase()}, ${merchantInfo.data[0].reg_province.toLowerCase()}`}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Business</p>
            </div>
            <div>
              <Tooltip title="Edit Business">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditBusiness(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Business Name"
                content={`${merchantInfo.data[0].business_name}`}
              />
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <DescriptionItem
                title="Business Address"
                content={`${merchantInfo.data[0].business_street}, ${
                  merchantInfo.data[0].business_barangay
                }, ${merchantInfo.data[0].business_city.toLowerCase()}, ${merchantInfo.data[0].business_province.toLowerCase()}`}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Contacts</p>
            </div>
            <div>
              <Tooltip title="Edit Contacts">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditContact(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={12}>
              <DescriptionItem
                title="Email"
                content={merchantInfo.data[0].merchantinfouser.email}
              />
            </Col>
            <Col span={12}>
              <DescriptionItem
                title="Contact Number"
                content={merchantInfo.data[0].reg_contact_no}
              />
            </Col>
          </Row>
          <Divider />
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ flexGrow: 1 }}>
              <p className="site-description-item-profile-p">Credentials</p>
            </div>
            <div>
              <Tooltip title="Edit Credentials">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setEditCredentials(true);
                  }}
                  icon={<EditOutlined />}
                />
              </Tooltip>
            </div>
          </div>
          <Row>
            <Col span={12}>
              <DescriptionItem
                title="Username"
                content={merchantInfo.data[0].merchantinfouser.username}
              />
            </Col>
            <Col span={12}>
              <PasswordItem />
            </Col>
          </Row>
        </>
      )}

      {editPersonal && (
        <EditPersonal
          open={editPersonal}
          close={() => setEditPersonal(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editBusiness && (
        <EditBusiness
          open={editBusiness}
          close={() => setEditBusiness(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editContact && (
        <EditContact
          open={editContact}
          close={() => setEditContact(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}

      {editCredentials && (
        <EditCredentials
          open={editCredentials}
          close={() => setEditCredentials(false)}
          data={merchantInfo.ready && merchantInfo.data[0]}
          getMyMerchantInfo={() => getMyMerchantInfo()}
        />
      )}
    </Drawer>
  );
};

export default AccountDetails;
